import { filledCount, BINDER_EVENT } from '@theme/binder-store';

/**
 * <s-binder-count> — keeps the header binder badge and its trigger's label in sync.
 *
 * Data: data-label-template — accessible label with a [count] placeholder.
 * Markup contract: [data-binder-badge] shows the number (hidden at zero);
 *   the closest <button> (or [data-binder-trigger]) receives the aria-label.
 */
class SBinderCount extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    const opts = { signal: this.#ac.signal };
    window.addEventListener(BINDER_EVENT, () => this.#sync(), opts);
    window.addEventListener('storage', () => this.#sync(), opts);
    this.#sync();
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  #sync() {
    const count = filledCount();
    const badge = this.querySelector('[data-binder-badge]');
    if (badge) {
      badge.textContent = String(count);
      badge.hidden = count === 0;
    }
    const trigger = this.querySelector('[data-binder-trigger]') ?? this.querySelector('button');
    const template = this.dataset.labelTemplate;
    if (trigger && template) trigger.setAttribute('aria-label', template.replace('[count]', String(count)));
  }
}

if (!customElements.get('s-binder-count')) customElements.define('s-binder-count', SBinderCount);
